import { defineModule } from '@portal/kernel';

export const manifest = defineModule({
  key: 'core-system',
  version: '0.1.0',
  kind: 'core',
  coreVersion: '^0.1.0',
  name: { vi: 'Hệ thống', en: 'System' },
  description: {
    vi: 'Thông tin hệ thống, danh mục module và các extension PostgreSQL dùng chung.',
    en: 'System information, module catalogue and shared PostgreSQL extensions.',
  },
  database: { schema: 'core_system' },
  permissions: [
    { key: 'core-system.module.view', name: { vi: 'Xem danh sách module', en: 'View modules' } },
    { key: 'core-system.module.manage', name: { vi: 'Quản lý module', en: 'Manage modules' } },
    {
      key: 'core-system.settings.manage',
      name: { vi: 'Cài đặt hệ thống và module', en: 'Manage system and module settings' },
    },
  ],
  navigation: [
    {
      id: 'dashboard',
      label: { vi: 'Tổng quan', en: 'Overview' },
      icon: 'layout-dashboard',
      path: '/',
      order: 0,
    },
    {
      id: 'admin',
      label: { vi: 'Quản trị', en: 'Administration' },
      icon: 'settings',
      order: 900,
      children: [
        {
          id: 'admin.modules',
          label: { vi: 'Module', en: 'Modules' },
          icon: 'blocks',
          path: '/admin/modules',
          permission: 'core-system.module.view',
          order: 10,
        },
        {
          id: 'admin.settings',
          label: { vi: 'Cài đặt', en: 'Settings' },
          icon: 'settings',
          path: '/admin/settings',
          permission: 'core-system.settings.manage',
          order: 5,
        },
        {
          id: 'admin.design-system',
          label: { vi: 'Design System', en: 'Design System' },
          icon: 'palette',
          path: '/admin/design-system',
          order: 90,
        },
      ],
    },
  ],
});
